
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ServicesHeaderProps {
  servicesCount: number;
}

export const ServicesHeader: React.FC<ServicesHeaderProps> = ({ servicesCount }) => {
  const { t } = useTranslation('dashboard');

  return (
    <div className="space-y-4">
      {/* Header section */}
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{t('servicesManagement.title')}</h1>
        <p className="text-gray-500">{t('servicesManagement.subtitle')}</p>
      </div>

      {/* Service count */}
      <div className="flex justify-between items-center">
        <p className="text-sm text-gray-500">
          {t('servicesManagement.servicesCount', { count: servicesCount })}
        </p>
      </div>
    </div>
  );
};
